import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [NgClass],
})
export class ModalComponent {
  @Input() public active: boolean = false;
  @Output() public dismiss: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Emits an event to dismiss the modal.
   */
  public dismissModal(): void {
    this.dismiss.emit();
  }
}
